import { Component } from '@angular/core';

@Component({
	selector: 'mb-families-container-skeleton',
	templateUrl: './families-container-skeleton.component.html',
	styleUrls: ['./families-container-skeleton.component.scss']
})
export class FamiliesContainerSkeletonComponent {

	public GHOST_ROWS = Array(5).fill(0);

}
